module.exports = __webpack_public_path__ + "static/media/arrow_forward_ios-24px.f40bc371.svg";